<template>
<div class="chapter">
<div class="inner_page">
<div id="Table-of-Contents.html" xml:lang="en-US">
<div class="Basic-Text-Frame-5">
<p class="TOCtitle"><span class="bold">Table of Contents</span></p>
<p class="TOCitem"><a href="#/NotJusttheBosssPlaything#Anchor-1">Not Just the Boss’s Plaything</a></p>
<p class="TOCitem"><span href="#/ADevilinDisguiseofbook2#Anchor-1" title="Link target outside of Sample">A Devil in Disguise</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TableofContents.vue?985daa28